import { render, staticRenderFns } from "./default_ReleaseDetails.vue?vue&type=template&id=78c07cf6&"
import script from "./default_ReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./default_ReleaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./default_ReleaseDetails.vue?vue&type=style&index=0&id=78c07cf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports